jQuery(function($) {
    var SetDesign = window.SetDesign;
    var addAction = SetDesign.addAction;
    var INIT = SetDesign.INIT;
    var LAYOUT = SetDesign.LAYOUT;
    addAction(INIT, function() {
        var $rows = $(".content-row");

        function applyClass() {
            var $container = $(this);
            var columnGroups = SetDesign.groupByRow($container.find("> .content-column").removeClass("content-column--last"));
            if (columnGroups.length) {
                var $last = columnGroups.pop();
                $last.addClass("content-column--last")
            }
        }
        $rows.each(applyClass);
        addAction(LAYOUT, function(widthHasChanged) {
            if (widthHasChanged) {
                $rows.each(applyClass)
            }
        })
    });
    addAction(INIT, function() {
        var $sliders = $(".content-slider--height-match");

        function fixHeight() {
            var $container = $(this);
            var $slides = $container.find(".vc-content-slide");
            $slides.css("min-height", "");
            var height = $slides.map(function() {
                return $(this).outerHeight()
            }).get().reduce(function(a, b) {
                return Math.max(a, b)
            });
            $slides.css("min-height", height + "px")
        }
        $sliders.each(fixHeight);
        addAction(LAYOUT, function() {
            $sliders.each(fixHeight)
        })
    })
});